// Filter option for search in select component of Ant Design
export const filterOptionForSearch = (input: string, option: { label: string; value: string } | undefined) => {
    const optionLabel = option?.label ?? '';
    const optionValue = String(option?.value ?? '');
    const search = input.toLowerCase();
    return (
        optionLabel.toLowerCase().includes(search) ||
        optionValue.toLowerCase().includes(search)
    );
}